import { ACCESS_EDIT, IAccessPayload } from 'redux/reducers/accessReducer';

export const setFullAccessAction = (payload: IAccessPayload) => ({
  type: ACCESS_EDIT,
  payload,
});
